// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { LineChart } from '../common/LineChart';
// Hooks:
import { useDatesChartData } from '../../hooks/useDatesChartData';
// Other
import { useTypedSelector } from '../../redux';

export const ViewsPerSession: React.FC = () => {
  const {
    data: { viewsPerSession },
    mode,
    startDate,
    endDate,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const {
    labelsNames, chartData,
  } = useDatesChartData(mode, viewsPerSession, startDate, endDate);

  return (
    <>
      {chartData.length > 0 && (
      <LineChart
        theme="green"
        title="Website Views per Session"
        subtitle="Amount open views per session. One session is one unique user."
        label="Views"
        labelsNames={labelsNames}
        data={chartData}
      />
      )}
    </>
  );
};
